/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Routemize_DTOs_ConnectCalendarToMicrosoftDto } from '../models/Routemize_DTOs_ConnectCalendarToMicrosoftDto';
import type { Routemize_DTOs_MicrosoftCalendarAuthResultDto } from '../models/Routemize_DTOs_MicrosoftCalendarAuthResultDto';
import type { Routemize_DTOs_MicrosoftCalendarDto } from '../models/Routemize_DTOs_MicrosoftCalendarDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MicrosoftCalendarService {
    /**
     * @param returnUrl
     * @returns string OK
     * @throws ApiError
     */
    public static getApiAppMicrosoftCalendarGetAuthorizationUrl(
        returnUrl?: string,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/microsoftCalendar/getAuthorizationUrl',
            query: {
                'returnUrl': returnUrl,
            },
        });
    }
    /**
     * @param authCode
     * @param stateCode
     * @returns Routemize_DTOs_MicrosoftCalendarAuthResultDto OK
     * @throws ApiError
     */
    public static getApiAppMicrosoftCalendarGetCompleteAuthorization(
        authCode?: string,
        stateCode?: string,
    ): CancelablePromise<Routemize_DTOs_MicrosoftCalendarAuthResultDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/microsoftCalendar/getCompleteAuthorization',
            query: {
                'authCode': authCode,
                'stateCode': stateCode,
            },
        });
    }
    /**
     * @returns boolean OK
     * @throws ApiError
     */
    public static postApiAppMicrosoftCalendarIsConnectedToMicrosoft(): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/microsoftCalendar/isConnectedToMicrosoft',
        });
    }
    /**
     * @param accountEmail
     * @returns Routemize_DTOs_MicrosoftCalendarDto OK
     * @throws ApiError
     */
    public static getApiAppMicrosoftCalendarGetAvailableCalendars(
        accountEmail?: string,
    ): CancelablePromise<Array<Routemize_DTOs_MicrosoftCalendarDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/microsoftCalendar/getAvailableCalendars',
            query: {
                'accountEmail': accountEmail,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppMicrosoftCalendarConnectCalendar(
        requestBody?: Routemize_DTOs_ConnectCalendarToMicrosoftDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/microsoftCalendar/connectCalendar',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param accountEmail
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppMicrosoftCalendarRevokeMicrosoftAccess(
        accountEmail?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/microsoftCalendar/revokeMicrosoftAccess',
            query: {
                'accountEmail': accountEmail,
            },
        });
    }
    /**
     * @param calendarId
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppMicrosoftCalendarDisconnectCalendar(
        calendarId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/microsoftCalendar/disconnectCalendar/{calendarId}',
            path: {
                'calendarId': calendarId,
            },
        });
    }
}
